export const PROCESSING_PATH = {
  FULL_T_R: 'Full T&R',
  TITLE_ONLY: 'Title Only',
  EARLY_REGISTRATION: 'Early/Same Day',
  SELF_REGISTRATION: 'Self T&R'
};

export const REGISTRATION_STATUS = {
  WITHIN_7DMBG: 'Within 7DMBG',
  READY_TO_WORK: 'Ready to Work',
  READY_TO_SUBMIT: 'Ready to Submit',
  DELAYED: 'Delayed',
  DELAYED_RESOLVED: 'Delay Resolved',
  SUBMITTED: 'Submitted',
  SUBMITTED_TITLE_ONLY: 'Submitted - Title Only',
  REJECTED: 'Submitted - On Hold',
  COMPLETED: 'Completed',
  REJECTED_RECEIVED: 'Rejected - Received',
  REJECTED_RESOLVED: 'Rejected - Resolved',
  PARTIAL_RECEIVED: 'Partial - Received',
  PARTIAL_RESOLVED: 'Delay Resolved',
  AWAITING_PAYMENT_CONFIRMATION: 'Awaiting Payment Confirmation',
  PACKET_MISSING: 'Packet Missing',
  TITLE_MISSING: 'Title Missing',
  PACKET_AND_TITLE_MISSING: 'Packet & Title Missing',
  TITLE_NOT_RECIEVED: 'Title Not Received',
  PACKET_NOT_RECEIVED: 'Packet Not Received',
  PACKET_AND_TITLE_NOT_RECEIVED: 'Packet & Title Not Received',
  CLOSED_ROLLED_BACK: 'Closed - Purchase Rolled Back',
  CLOSED_BACKED_OUT: 'Closed - Purchase Backed Out',
  TOTAL_LOSS: 'Total Loss',
  PENDING_EXCHANGE: 'Pending Exchange'
};

export const PROCESSED_STATUS = {
  ACTIVE: 'ACTIVE',
  PENDING: 'PENDING',
  NOT_STARTED: 'NOT_STARTED',
  NOT_FOUND: 'NOT_FOUND',
  PAPERWORK_RECEIVED: 'PAPERWORK_RECEIVED',
  ACTION_REQUIRED: 'ACTION_REQUIRED',
  SUBMITTED_FOR_PROCESSING: 'SUBMITTED_FOR_PROCESSING',
  COMPLETED: 'COMPLETED',
  TOTAL_LOSS: 'TOTAL_LOSS',
  EXPIRED: 'EXPIRED',
  X1_ACTIVE_ITEMS: 'X1_ACTIVE_ITEMS',
  X2_ACTIVE_ITEMS: 'X2_ACTIVE_ITEMS',
  X3_ACTIVE_ITEMS: 'X3_ACTIVE_ITEMS',
  X4_ACTIVE_ITEMS: 'X4_ACTIVE_ITEMS',
  PAUSED: 'PAUSED'
};

export const statusLabels = {
  ACTIVE: 'Active',
  PENDING: 'Starting soon',
  NOT_STARTED: 'Starting soon',
  PAPERWORK_RECEIVED: 'Paperwork received',
  ACTION_REQUIRED: 'Action required',
  SUBMITTED_FOR_PROCESSING: 'Submitted for processing',
  EXPIRED: 'Expired',
  COMPLETED: 'Completed',
  TOTAL_LOSS: 'Total loss',
  X1_ACTIVE_ITEMS: '1 Active item',
  X2_ACTIVE_ITEMS: '2 Active items',
  X3_ACTIVE_ITEMS: '3 Active items',
  X4_ACTIVE_ITEMS: '4 Active items',
  PAUSED: 'Exchange Pending'
};

export default {
  statusLabels
};
